import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import App from './App';
import * as serviceWorker from './serviceWorker';

import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router';
import GTMTracking from './_tracking';

if (!window.$affiliate) {
    /* initialize Google Tag Manager */
    window.$gtmTracking = new GTMTracking();
    window.$dataLayer = [];
}

const container: HTMLElement = document.getElementById('root') as HTMLElement;
const root = createRoot(container!);
root.render(
    <HashRouter>
        <App />
    </HashRouter>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
